<template>
  <div>
    <new-form type="Management"></new-form>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  mounted() {
    if (this.$route.params.state == "Management") {
      fetch("https://api.ipify.org?format=json")
        .then(x => x.json())

        .then(({ ip }) => {
          setTimeout(() => {
            window.axios
              .post("api/geoRent", { rawIp: ip, tagId: 4 })
              .then(res => {
                console.log(res.data);
                this.$route.params.state = "";
              });
          }, 10000);
        });
    }
  },

  methods: {}
};
</script>
